var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6738 2.61564C15.1867 1.9591 14.7189 1 13.8857 1H3.88565C3.0525 1 2.5847 1.9591 3.09762 2.61564L7.92362 8.72867C8.06098 8.90449 8.1356 9.1212 8.1356 9.34432V14.7961C8.1356 14.9743 8.35103 15.0635 8.47702 14.9375L9.48915 13.9254C9.58292 13.8316 9.6356 13.7044 9.6356 13.5718V9.34432C9.6356 9.1212 9.71022 8.90449 9.84758 8.72867L14.6738 2.61564Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.0d054b0d48785558ef62175580c2c6bd.svg";
export { ForwardRef as ReactComponent };